import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-placeholder disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        className
      )}
      {...props}
    />
  );
}

interface InputWithIconProps extends React.ComponentProps<"input"> {
  icon?: React.ElementType;
  iconClassName?: string;
  wrapperClassName?: string;
}

function InputWithIcon({ className, type, icon: Icon, iconClassName, wrapperClassName, ...props }: InputWithIconProps) {
  const defaultIconClassName = "size-4 shrink-0 opacity-50";

  return (
    <div
      className={cn(
        "relative flex h-9 w-full items-center gap-2 rounded-md border border-input bg-transparent px-3 shadow-xs transition-[color,box-shadow]",
        "focus-within:border-ring focus-within:ring-[3px] focus-within:ring-ring/50",
        "has-[input:disabled]:pointer-events-none has-[input:disabled]:cursor-not-allowed has-[input:disabled]:opacity-50",
        "has-[input[aria-invalid=true]]:border-destructive has-[input[aria-invalid=true]]:ring-destructive/20 dark:has-[input[aria-invalid=true]]:ring-destructive/40",
        wrapperClassName
      )}
    >
      {Icon && <Icon className={cn(defaultIconClassName, iconClassName)} />}
      <input
        type={type}
        data-slot="input"
        className={cn(
          "flex h-full w-full bg-transparent py-1 text-base outline-none selection:bg-primary selection:text-primary-foreground placeholder:text-placeholder md:text-sm",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...props}
      />
    </div>
  );
}

export { Input, InputWithIcon };
